
import Vue from "vue";
import VueRouter from "vue-router";
import Products from "@/views/membership/Products";
import PartiesManage from "@/views/membership/PartiesManage";
import Account from "@/views/membership/Account";
import Message from "@/views/membership/Message";
import Changepass from "@/views/membership/Changepass";
import CustomerTodo from "@/views/membership/CustomerTodo";
import Inventory from "@/views/membership/Inventory";
import DaifaIntegration from "@/views/membership/DaifaIntegration";
import InvoiceTitle from "@/views/membership/InvoiceTitle";

Vue.use(VueRouter);

export default [
  {
    meta: {
      title: "产品管理"
    },
    path: "products",
    name: "Products",
    component: Products
  },
  {
    meta: {
      title: "我的库存"
    },
    path: "inventory",
    name: "Inventory",
    component: Inventory
  },
  {
    meta: {
      title: "代发对接"
    },
    path: "daifaIntegration",
    name: "DaifaIntegration",
    component: DaifaIntegration
  },
  {
    meta: {
      title: "发票抬头"
    },
    path: "invoiceTitle",
    name: "InvoiceTitle",
    component: InvoiceTitle
  },
  {
    meta: {
      title: "收发通管理"
    },
    path: "parties",
    name: "PartiesManage",
    component: PartiesManage
  },
  // 旧菜单兼容：跳转到收发通对应 Tab
  {
    path: "supplier",
    redirect: { path: "/parties", query: { tab: "supplier" } }
  },
  {
    path: "managementdef",
    redirect: { path: "/parties", query: { tab: "importer" } }
  },
  {
    path: "shippermanagement",
    redirect: { path: "/parties", query: { tab: "shipper" } }
  },
  {
    meta: {
      title: "账号管理"
    },
    path: "account",
    name: "Account",
    component: Account
  },
  {
    meta: {
      title: "修改密码"
    },
    path: "changepass",
    name: "Changepass",
    component: Changepass
  },
  {
    meta: {
      title: "消息中心"
    },
    path: "message",
    name: "Message",
    component: Message
  },
  {
    meta: {
      title: "我的待办"
    },
    path: "customerTodo",
    name: "CustomerTodo",
    component: CustomerTodo
  }
]
